export const FETCH_SESSIONS_REQUEST = 'fetch_sessions_request';
export const FETCH_SESSIONS_SUCCESS = 'fetch_sessions_success';
export const FETCH_SESSIONS_ERROR = 'fetch_sessions_error';

export const FETCH_SESSION_REQUEST = 'fetch_session_request';
export const FETCH_SESSION_SUCCESS = 'fetch_session_success';
export const FETCH_SESSION_ERROR = 'fetch_session_error';

export const FETCH_SESSION_FILES_REQUEST = 'fetch_session_files_request';
export const FETCH_SESSION_FILES_SUCCESS = 'fetch_session_files_success';
export const FETCH_SESSION_FILES_ERROR = 'fetch_session_files_error';

export const FETCH_MAPPING_REQUEST = 'fetch_mapping_request';
export const FETCH_MAPPING_SUCCESS = 'fetch_mapping_success';
export const FETCH_MAPPING_ERROR = 'fetch_mapping_error';

export const ADD_FILE_REQUEST = 'add_file_request';
export const ADD_FILE_SUCCESS = 'add_file_success';
export const ADD_FILE_ERROR = 'add_file_error';

export const DELETE_SESSION_REQUEST = 'delete_session_request';
export const DELETE_SESSION_SUCCESS = 'delete_session_success';
export const DELETE_SESSION_ERROR = 'delete_session_error';

export const DELETE_SESSION_FILE_REQUEST = 'delete_session_file_request';
export const DELETE_SESSION_FILE_SUCCESS = 'delete_session_file_success';
export const DELETE_SESSION_FILE_ERROR = 'delete_session_file_error';

export const SAVE_SESSION_REQUEST = 'save_session_request';
export const SAVE_SESSION_SUCCESS = 'save_session_success';
export const SAVE_SESSION_ERROR = 'save_session_error';

export const UPDATE_SESSION_NAME_REQUEST = 'update_session_name_request';
export const UPDATE_SESSION_NAME_SUCCESS = 'update_session_name_success';
export const UPDATE_SESSION_NAME_ERROR = 'update_session_name_error';

export const UPDATE_SESSION_HIDE_REQUEST= 'update_session_hide_request';
export const UPDATE_SESSION_HIDE_SUCCESS= 'update_session_hide_success';
export const UPDATE_SESSION_HIDE_ERROR=   'update_session_hide_error';
export const UPDATE_FILE_ACTIVE_REQUEST = 'update_file_active_request';
export const UPDATE_FILE_ACTIVE_SUCCESS = 'update_file_active_success';
export const UPDATE_FILE_ACTIVE_ERROR = 'update_file_active_error';

export const UPDATE_FILE_FILENAME_REQUEST = 'update_file_filename_request';
export const UPDATE_FILE_FILENAME_SUCCESS = 'update_file_filename_success';
export const UPDATE_FILE_FILENAME_ERROR = 'update_file_filename_error';

export const UPDATE_FILE_RULES_APPLIED = 'update_file_rules_applied';
export const UPDATE_FILE_NOTES_EDITOR_CONTENT = 'update_file_notes_editor_content';
export const UPDATE_FILE_SKIPPED_COLUMNS_HIDDEN = 'update_file_skipped_columns_hidden';
export const MOVE_VIRTUAL_FILE_ERROR = 'move_virtual_file_error';
export const MOVE_VIRTUAL_FILE_REQUEST = 'move_virtual_file_request';
export const MOVE_VIRTUAL_FILE_SUCCESS = 'move_virtual_file_success';
export const CREATE_VIRTUAL_FILE_START = 'create_virtual_file_start';
export const CREATE_VIRTUAL_FILE_DONE = 'create_virtual_file_done';

export const ADD_MESSAGE = 'add_message';
export const DELETE_MESSAGE = 'delete_message';

export const CREATE_NEW_RULE = 'create_new_rule';
export const DELETE_RULE = 'delete_rule';
export const UPDATE_RULE_ORDER = 'update_rule_order';
export const UPDATE_RULE_ACTIVE = 'update_rule_active';
export const UPDATE_RULE = 'update_rule';

export const APPLY_RULE_START = 'apply_rules_start';
export const APPLY_CONVERSION = 'apply_conversion';
export const APPLY_RULE_DONE = 'apply_rules_done';

export const SET_METADATA_TYPE = 'set_metadata_type';
export const SET_METADATA_FORMAT = 'set_metadata_format';
export const SET_METADATA_FIELD_TYPE = 'set_metadata_field_type';
export const CREATE_NEW_METADATA = 'create_new_metadata';

export const UPDATE_METADATA_ORDER = 'update_metadata_order';
export const CREATE_JOIN_ITEM = 'create_join_item';
export const DELETE_MAPPING_ITEM = 'delete_mapping_item';
export const DELETE_METADATA_ITEM = 'delete_metadata_item';
export const CLEAR_MAPPING = 'clear_mapping';
export const SET_TARGET_VALUE = 'set_target_value';
export const UPDATE_MUTATED_DATA = 'update_mutated_data';
export const SAVE_SESSION = 'save_session';
export const UPDATE_SEARCH_TERM = 'update_search_term';
export const RESET_STATE = 'reset_state';

export const FETCH_SETTINGS_REQUEST = 'fetch_settings_request';
export const FETCH_SETTINGS_SUCCESS = 'fetch_settings_success';
export const FETCH_SETTINGS_ERROR = 'fetch_settings_error';

export const UPDATE_SETTINGS_HIDE_ARCHIVED_FILES_REQUEST = "update_settings_hide_archived_files_request"
export const UPDATE_SETTINGS_HIDE_ARCHIVED_FILES_SUCCESS = "update_settings_hide_archived_files_success"
export const UPDATE_SETTINGS_HIDE_ARCHIVED_FILES_ERROR = "update_settings_hide_archived_files_error"
